import styled from "styled-components";

export const OurCoreValuesStyle = styled.article`
  display: grid;
  grid-template-columns: repeat(3, 1fr);

  @media(max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;


